import { CVA_AUTH_MODULES } from "../models/auth.modules.enum";

export const ROUTE_CONSTANTS = {
  LOGIN: 'auth/login',
  TWO_STEP_VERIFICATION: 'auth/two-step-verification',
  DASHBOARD: 'dashboard',
  APPOINTMENT: 'appointment',
  PATIENT_DASHBOARD: 'patient-dashboard',
  SOAP_NOTES: 'soap-notes',
  CHANGE_PASSWORD: 'change-password',
  RESET_PASSWORD: 'reset-password',
  SOAP_CONFIGURATION: 'soap-configuration',
  FORGOT_PASSWORD: 'forgot-password',
  CONSULTATION: 'consultation',
  MANAGE_TEMPLATES: 'templates',
  LIC: 'lic',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  PATIENT_SEARCH: 'paient-search',
  FACILITY_SELECTION: 'facility-selection',
  CREATE: 'create',
  EDIT: 'edit',
  PRACTICE_SIGNUP: 'practice-signup',
  FIND_MY_FACILITY_ID: 'find-my-facility-id',
  TUTORIAL_LINK: 'tutorial',
  LIC_SESSION_EXPIRED: 'session-expired',
};

export const API_ROUTES = {
  ALLERGIES_BY_PATIENT_ID: '/allergy/patient',
  IMMUNIZATION_BY_PATIENT_ID: '/immunization/patient',
  PREVIOUS_CONSULTATION_BY_PATIENT_ID: '/soap-note/patient',
  APPOINTMENT: '/appointment',
  VITALS_BY_APPOINTMENT_ID: '/observation/appointment',
  VITALS_BY_PATIENT_ID: '/observation/patient',
  PATIENT: '/patient',
  START_CONSULTATION: '/soap-note/start-consultation',
  PRACTITIONER: '/practitioner',
  SLOT: '/slot',
  USER_SETTING: '/user-settings',
  NLP: '/soap-note/nlp',
  LOOKUP: '/lookup',
  MANUAL_REFRESH: '/manual-refresh',
  SNOMED_CODE: '/snomed-code',
  LIC_LOGIN: '/custom/lic-login',
  VALIDATE_LOGIN_OTP: '/custom/validate-login-otp',
  MEDICATION_REQUEST_BY_PATIENT_ID: '/medication-request/patient',
  LAB_RESULTS: '/lab-results/patient',
  FORGOT_PASSWORD: '/custom/forgot-password',
  LAB_ORDER_HISTORY: '/lab-results/patient',
  HISTORICAL_DATA: '/historical-data',
  LIST_FACILITY: '/custom/facilityid',
  NOTE_TEMPLATES: 'note-template-listing',
  CUSTOM_TEMPLATE: '/custom-template',
  GENERATE: '/generate',
  GENERATE_PREVIEW: '/generate-preview',
  SUBSCRIPTION_DETAILS: 'user-management-extension/subscription-details',
  TOGGLE_TEMPLATE_FAV_STATUS: '/toggle-template-favorite-status',
  USER_FAV_TEMPLATE: '/user-favorite-template',
  PRACTISE_SIGNIP: '/practice-signup',
  CONTENT: '/content',
  TASK: '/task',
  AI_PROXY: '/ai-proxy',
  REFINE_NOTE: '/refine',
  GENERATE_TASKS: '/generate-recommended-tasks',
  GENERATE_MEDICATIONS: '/generate-recommended-medications',
  GENERATE_CLASSIFICATION: '/generate-recommended-classification',
  CLASSIFICATIONS_LOOKUP: '/classifications-lookup/getClassificationList',
  GENERATE_CDM_PLAN: '/generate-cdmPlan',
  // GENERATE_HISTORY_SUMMARY: '/generate_history_summary',
  GENERATE_CONDITION_HISTORY_SUMMARY: '/generate_condition_history_summary',
  GENERATE_VITALS: '/generate-vitals',
  MEDICATION_REQUEST: '/medication-request',
  CONDITION: '/condition',
  REFRESH_TOKEN: '/custom/refresh',
  SESSION_LOGIN: '/custom/session-login',
  GENERATE_ACC_ELIGIBILITY: '/generate-recommended-acc-eligibility',
  SAVE_ACC_ELIGIBILITY: '/save-acc-eligibility',
  GENERATE_ACC_SERVICE_CODE: '/generate-recommended-acc-service-eligibility',
  STT_AUDIO_GATEWAY: '/audio-gateway',
  NOTIFICATION_ACTIVITY: '/notification-activity',
  CHECK_TOUR_STATUS: '/check-tour-status',
  SET_INITIAL_TOUR_STATUS: '/set-initial-tour-status',
};

export const AUTH_MODULE_ROUTE_MAP = {
  [ROUTE_CONSTANTS.APPOINTMENT]: CVA_AUTH_MODULES.CVA_APPOINTMENT,
  [ROUTE_CONSTANTS.PATIENT_DASHBOARD]: CVA_AUTH_MODULES.CVA_APPOINTMENT,
  [ROUTE_CONSTANTS.SOAP_CONFIGURATION]: CVA_AUTH_MODULES.CVA_CONFIGURATION,
  [ROUTE_CONSTANTS.SOAP_NOTES]: CVA_AUTH_MODULES.CVA_SOAP_NOTES,
  [ROUTE_CONSTANTS.CHANGE_PASSWORD]: CVA_AUTH_MODULES.CVA_PRACTITIONER,
  [ROUTE_CONSTANTS.CONSULTATION]: CVA_AUTH_MODULES.CVA_SOAP_NOTES,
  [ROUTE_CONSTANTS.PATIENT_SEARCH]: CVA_AUTH_MODULES.CVA_PATIENT,
  [ROUTE_CONSTANTS.MANAGE_TEMPLATES]: CVA_AUTH_MODULES.CVA_SOAP_NOTES
}

